/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierPerformanceProfile.ts     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-performance-profile";

export class AutogenModelCarrierPerformanceProfile<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierPerformanceProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierPerformanceProfile extends ModelRow<RowCarrierPerformanceProfileFields> {
	constructor(values?: Partial<RowCarrierPerformanceProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierPerformanceProfileFields {
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
}

